import React, { useState } from 'react';
import { Snackbar, Alert, Chip, Typography, Stack } from '@mui/material';
// import RequestDialog from './RequestDialog';
// import { checkPaymentStatus, getAllPayments } from 'API/AgentOnboarding/api';
// import { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { useNavigate } from 'react-router';

export default function PaymentTable(props) {
  const navigate = useNavigate();
  const DataTable = props.ResData;


  function formatToCustomDateTime(input) {
    const date = new Date(input);
    if (isNaN(date.getTime())) return 'Invalid Date';

    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const yyyy = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert 0 to 12 for 12 AM
    const hh = String(hours).padStart(2, '0');

    return `${dd}-${mm}-${yyyy} | ${hh}:${minutes}:${seconds} ${ampm}`;
  }

  const [OpenAlert, setOpenAlert] = useState(false);
  const [Success, setSuccess] = useState(false);
  const [Err, setErr] = useState(false);
  const [CreateCsp, setCreateCsp] = useState(false);

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setSuccess(false);
    setErr(false);
    setCreateCsp(false);
  };

  return (
    <div>
      <Snackbar open={OpenAlert} anchorOrigin={{ horizontal: 'right', vertical: 'top' }} autoHideDuration={6000} onClose={handleCloseAlert}>
        <Alert onClose={handleCloseAlert} severity="error" variant="filled" sx={{ width: '100%' }}>
          Something went wrong
        </Alert>
      </Snackbar>
      <Snackbar open={Success} anchorOrigin={{ horizontal: 'right', vertical: 'top' }} autoHideDuration={6000} onClose={handleCloseAlert}>
        <Alert onClose={handleCloseAlert} severity="success" variant="filled" sx={{ width: '100%' }}>
          {Success}
        </Alert>
      </Snackbar>
      <Snackbar open={Err} anchorOrigin={{ horizontal: 'right', vertical: 'top' }} autoHideDuration={6000} onClose={handleCloseAlert}>
        <Alert onClose={handleCloseAlert} severity="error" variant="filled" sx={{ width: '100%' }}>
          {Err}
        </Alert>
      </Snackbar>
      <Snackbar open={CreateCsp} anchorOrigin={{ horizontal: 'right', vertical: 'top' }} autoHideDuration={6000} onClose={handleCloseAlert}>
        <Alert onClose={handleCloseAlert} severity="error" variant="filled" sx={{ width: '100%' }}>
          user Code is missing
        </Alert>
      </Snackbar>

      {DataTable && DataTable.length ? (
        <Paper sx={{ width: '100%' }}>
          <TableContainer sx={{ maxHeight: 500, width: 1200 }}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: '#592375' }}>Agent Name</TableCell>
                  <TableCell sx={{ color: '#592375' }}>Agent Code</TableCell>
                  <TableCell sx={{ color: '#592375' }}>Mobile No.</TableCell>
                  <TableCell sx={{ color: '#592375' }}>District</TableCell>
                  <TableCell sx={{ color: '#592375' }}>Bank Name</TableCell>
                  <TableCell sx={{ color: '#592375' }}>KYC Approval Date</TableCell>
                  <TableCell sx={{ color: '#592375' }}>Action</TableCell>
                  {/* <TableCell sx={{width:130}}>Resend Link</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {DataTable &&
                  DataTable
                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      return (
                        <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                          <TableCell>{row.user_data.agent_name}</TableCell>
                          <TableCell>{row.user_data.agent_code}</TableCell>
                          <TableCell sx={{ alignItems: 'center' }}>{row.user_data.mobile_number}</TableCell>
                          <TableCell>{row.user_data.district}</TableCell>
                          <TableCell>{row.product_data ? row.product_data.bank_name : '-'}</TableCell>
                          <TableCell>{formatToCustomDateTime(row.kiosk_submission)}</TableCell>

                          <TableCell sx={{ cursor: 'pointer' }}>

                            <Chip
                              label="Create CSP Code +"
                              color="secondary"
                              onClick={() => {
                                if (row.user_data.agent_name) {
                                  navigate('/Admin/Code_Activation_Details', {
                                    state: {
                                      type: 'create',
                                      code: row.user_data.agent_code,
                                      name: row.user_data.agent_name,
                                      id: row._id,
                                      userId: row.user_id,
                                      // productId:row.product_id,
                                      bank: row.product_data.bank_name,
                                      payment_data: row.payment_data
                                    }
                                  });
                                } else {
                                  setCreateCsp(true);
                                }
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            sx={{ width: '100%' }}
            rowsPerPageOptions={[10, 50, 100]}
            component="div"
            count={props.TotalCount}
            rowsPerPage={props.rowsPerPage}
            page={props.page}
            onPageChange={props.handleChangePage}
            onRowsPerPageChange={props.handleChangeRowsPerPage}
          />
        </Paper>
      ) : (
        <Stack justifyContent="center" alignItems="center">
          {/* <CircularProgress /> */}
          <Typography mt={1} variant="h5">
            No data found
          </Typography>
        </Stack>
      )}
    </div>
  );
}
